import Container from './profile-container';

export default Container;
